const CONFIG_MISSING_MESSAGE = "Configuration or it's required part missing. Please message system administrator!";

export default {
  webSocketConfig: state => {
    if (!state.config || !state.config.webSocketConfig) {
      // eslint-disable-next-line no-console
      console.error(CONFIG_MISSING_MESSAGE);
      return {};
    }
    return state.config.webSocketConfig;
  }
};
